"use client"

import blackTicketLogo from '../../assets/images/blackTicketLogo.png';

/* ──────────────────────────────────────────────────────────────────────────
 * AnimatedTicketLogo — the brand mark for the loading screen.
 * Static mark with a crisp BLACK OUTLINE, and the only motion is the GLARE:
 * a diagonal light band that sweeps across the mark, masked to its exact
 * silhouette so the glint rides the logo shape, not a rectangle.
 * (No pulsing / no float — removed per design.)
 * ────────────────────────────────────────────────────────────────────────── */

const LOGO_SRC = blackTicketLogo.src;
const ASPECT = 1.5; // 1536 × 1024

// Crisp black outline around the PNG's alpha silhouette — 8 directions so the
// stroke stays even around curves/corners.
const OUTLINE = 1.5; // px
const OUTLINE_FILTER = [
    [OUTLINE, 0], [-OUTLINE, 0], [0, OUTLINE], [0, -OUTLINE],
    [OUTLINE, OUTLINE], [OUTLINE, -OUTLINE], [-OUTLINE, OUTLINE], [-OUTLINE, -OUTLINE],
].map(([x, y]) => `drop-shadow(${x}px ${y}px 0 #000)`).join(' ');

const AnimatedTicketLogo = ({ width = 150 }) => {
    const height = Math.round(width / ASPECT);
    const maskBox = {
        WebkitMaskImage: `url(${LOGO_SRC})`,
        maskImage: `url(${LOGO_SRC})`,
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
    };

    return (
        <div
            className='tcktLogo'
            style={{ position: 'relative', right: 10, width, height, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
            {/* the brand mark with a black outline */}
            <img
                src={LOGO_SRC}
                alt='tcktpass'
                className='tcktLogo__mark'
                fetchPriority='high'
                decoding='async'
                style={{ position: 'relative', width, height, objectFit: 'contain' }}
            />

            {/* glare — light band, masked to the logo's exact silhouette */}
            <div
                aria-hidden
                className='tcktLogo__shineMask'
                style={{ position: 'absolute', inset: 0, overflow: 'hidden', ...maskBox }}
            >
                <div className='tcktLogo__shineBand' />
            </div>

            <style>{`
                .tcktLogo {
                    animation: tcktLogoScale 1.5s ease-in-out infinite;
                    will-change: transform;
                }
                .tcktLogo__shineBand {
                    position: absolute;
                    top: -25%;
                    left: 0;
                    width: 45%;
                    height: 150%;
                    background: linear-gradient(
                        100deg,
                        rgba(255,255,255,0) 0%,
                        rgba(255,255,255,0.85) 50%,
                        rgba(255,255,255,0) 100%
                    );
                    transform: translateX(-200%) skewX(-12deg);
                    animation: tcktLogoShine 1.5s ease-in-out infinite;
                    will-change: transform;
                }
                @keyframes tcktLogoShine {
                    0%        { transform: translateX(-200%) skewX(-12deg); }
                    55%, 100% { transform: translateX(360%) skewX(-12deg); }
                }
                @keyframes tcktLogoScale {
                    0%, 100% { transform: scale(1); }
                    50%      { transform: scale(1.03); }
                }
                @media (prefers-reduced-motion: reduce) {
                    .tcktLogo,
                    .tcktLogo__shineBand { animation: none; }
                }
            `}</style>
        </div>
    );
};

export default AnimatedTicketLogo;
